import { environment as defaultEnvironment } from './environment';

export const environmentLoader: Promise<any> = new Promise<any>((resolve) => {
    const xmlHttp = new XMLHttpRequest(),
        method = 'GET',
        url = './assets/environments/env.json';
    xmlHttp.open(method, url, true);
    xmlHttp.onload = function (): void {
        if (xmlHttp.status === 200) {
            resolve(JSON.parse(xmlHttp.responseText));
        } else {
            resolve(defaultEnvironment);
        }
    };
    xmlHttp.send();
});
